import React from "react";
import { connect } from "react-redux";
import { getNotificacionesAdmin,borrarNotificacion } from "./NotificacionService";
import Spinner from "react-bootstrap/Spinner";
import ComponenteVacio from "../componentes/avisos/ComponenteVacio";
import { Link } from "react-router-dom";
import ModalNotificacion from "./ModalNotificacion";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import MensajeFlash from "../mensajeFlash/MensajeFlash";

class Borradores extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 10,
      search: "",
      loading: true,
      notificaciones: [],
      totalCount: 0,
      totalPages: 0,
      openModal: false,
      idNotificacion: null,
      dialogEliminar: false,
      openPantallaCarga: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "",
      mostrarMensajeFlash: false,
    };
  }

  componentDidMount() {
    this.fetchNotificaciones(0, this.state.pageSize, "");
  }

  fetchNotificaciones(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getNotificacionesAdmin(page, pageSize, search, "01").then(() => {
      this.setState({
        notificacionesAdmin:
          this.props.notificacionesAdminData.notificacionesAdmin,
        page: this.props.notificacionesAdminData.page,
        totalCount: this.props.notificacionesAdminData.totalCount,
        totalPages: Math.ceil(
          this.props.notificacionesAdminData.totalCount / pageSize
        ),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchNotificaciones(0, this.state.pageSize, this.state.search);
    });
  };

  setOpenModal = (valor, idNotificacion = null) => {
    this.setState({ openModal: valor, idNotificacion: idNotificacion });
  };
handleDelete = () => {
  this.setState({ openPantallaCarga: true});
  borrarNotificacion(this.state.idNotificacion).then((response) => {
    if (response.error) {
      this.setState({
        mensajeFlashSeverity: "danger",
        mensajeFlash: response.mensaje,
        mostrarMensajeFlash: true,
        openPantallaCarga: false,
      });
    } else {
      this.setState({
        mensajeFlash: "Notificación eliminada correctamente",
        mensajeFlashSeverity: "success",
        mostrarMensajeFlash: true,
        openPantallaCarga: false,
      });
    }
    this.handleDialogEliminar(false);
    this.fetchNotificaciones(0, this.state.pageSize, "");
  });
};
  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchNotificaciones(
          newPage,
          this.state.pageSize,
          this.state.search
        );
      });
    }
  };

handleDialogEliminar = (value, id = null) => {
  this.setState({
    dialogEliminar: value,
    idNotificacion: id,
  });
};

  // Clase CSS para el estado de la notificación
  getStatusClass = (estado) => {
    switch (estado) {
      case "Leída":
        return "label__success";
      case "Sin leer":
        return "label__info";
      case "Pendiente":
        return "label__default";
      default:
        return "label__info";
    }
  };

  renderNotificacion = (notificacion, index) => {
    return (
      <div
        key={index}
        className={`list-item ${
          notificacion.tipo.codigo === "03"
            ? "type-danger"
            : notificacion.tipo.codigo === "01"
            ? "type-warning"
            : "type-info"
        }`}
        onClick={() => this.setOpenModal(true,notificacion.id)}
      >
        <Link
          to={{
            pathname: "/notificaciones/crear-notificacion",
            idNotificacion: notificacion.id,
            tipoAccion: 'edit'
          }}
          className="list-item__link"
        >
          <div className="item-info">
            {/* Icono */}
            <div className="icon-shape">
              <span className="material-symbols-outlined"> notifications </span>
            </div>

            {/* Texto */}
            <div className="item-copy">
              <span className="copy__uppertitle">
                {notificacion.nombreCreador}
              </span>
              <h3 className="copy__title">{notificacion.titulo}</h3>
              <p className="copy__description">{notificacion.resumen}</p>
            </div>
          </div>

          <div className="item-elements">
            <div className="item__status">
              <span
                className={this.getStatusClass(notificacion.estado.descripcion)}
              >
                {notificacion.estado.descripcion}
              </span>
            </div>
            <time className="item__date" dateTime={notificacion.fechaCreacion}>
              {new Date(notificacion.fechaCreacion).toLocaleDateString(
                "es-ES",
                {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                }
              )}
            </time>
          </div>
          <div className="item-actions">
            {/*    <button className="btn-small btn-primary-tonal btn-circle-icon">
            <span className="material-symbols-outlined">content_copy</span>
            <span className="mobile-txt">Copiar</span>
          </button> */}
<button
  type="button"
  className="btn-small btn-primary-tonal btn-circle-icon"
  onClick={(e) => {
    e.preventDefault();      // para que no navegue el Link
    e.stopPropagation();     // para que no dispare el onClick del contenedor
    this.handleDialogEliminar(true, notificacion.id);
  }}
>
  <span className="material-symbols-outlined">delete</span>
  <span className="mobile-txt">Eliminar</span>
</button>
          </div>
        </Link>
      </div>
    );
  };

  render() {
    return (
      <div className="component-lista-documentos">
        <div className="component-container">
          <h5 className="list-title">Notificaciones</h5>

          {/* Buscador */}
          <form className="search-form form">
            <div className="search-group">
              <div className="input-icon">
                <span className="material-symbols-outlined">search</span>
              </div>
              <input
                type="search"
                className="input-search"
                placeholder="Buscar.."
                aria-label="Search"
                value={this.state.search}
                onChange={this.handleSearchChange}
              />
            </div>
          </form>
<ModalEliminarConDetalles
  isOpen={this.state.dialogEliminar}
  titulo="Notificación"
  elemento={this.state.idNotificacion}   // o el objeto si luego lo buscas
  onConfirmar={this.handleDelete}
  cerrarModal={() => this.handleDialogEliminar(false)}
  mensaje="Esta acción eliminará permanentemente la notificación"
  textoBotonAccion="CONFIRMAR ELIMINACIÓN"
/>
          <ModalNotificacion
            open={this.state.openModal}
            onClose={() => this.setOpenModal(false)}
            idNotificacion={this.state.idNotificacion}
          />
                              <MensajeFlash
                      visible={this.state.mostrarMensajeFlash}
                      mensaje={this.state.mensajeFlash}
                      severity={this.state.mensajeFlashSeverity} />
          {/* Lista */}
          {this.state.loading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
            </div>
          ) : this.state.notificacionesAdmin.length > 0 ? (
            this.state.notificacionesAdmin.map(this.renderNotificacion)
          ) : (
            <ComponenteVacio />
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getNotificacionesAdmin: (page, size, search, estado) =>
    dispatch(getNotificacionesAdmin(page, size, search, estado)),
});

const mapStateToProps = (state) => ({
  notificacionesAdminData: state.notificacionesAdminData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Borradores);
